import Icon from '../components/Icon.vue'

Icon.register({
  'file-invoice-dollar': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM64 72C64 67.6 67.6 64 72 64H152C156.4 64 160 67.6 160 72V88C160 92.4 156.4 96 152 96H72C67.6 96 64 92.4 64 88V72zM64 152V136C64 131.6 67.6 128 72 128H152C156.4 128 160 131.6 160 136V152C160 156.4 156.4 160 152 160H72C67.6 160 64 156.4 64 152zM208 415.9V440C208 444.4 204.4 448 200 448H184C179.6 448 176 444.4 176 440V415.7C164.7 415.1 153.7 411.2 144.6 404.4 140.7 401.4 140.5 395.6 144.1 392.2L155.8 381C158.6 378.4 162.7 378.3 165.9 380.3 169.8 382.7 174.2 384 178.8 384H206.9C213.4 384 218.7 378.1 218.7 370.8 218.7 364.9 215.1 359.6 209.9 358.1L164.9 344.6C146.3 339 133.3 321.2 133.3 301.2 133.3 276.7 152.4 256.8 176 256.1V232C176 227.6 179.6 224 184 224H200C204.4 224 208 227.6 208 232V256.3C219.3 256.9 230.3 260.8 239.4 267.6 243.3 270.6 243.5 276.4 239.9 279.8L228.2 291C225.4 293.6 221.3 293.8 218.1 291.7 214.2 289.3 209.8 288 205.2 288H177.1C170.6 288 165.3 293.9 165.3 301.2 165.3 307.1 168.9 312.4 174.1 313.9L219.1 327.4C237.7 333 250.7 350.8 250.7 370.8 250.7 395.3 231.6 415.3 208 415.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-invoice-dollar.js
// module id = qStl
// module chunks = 144